import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Form, Modal, Row, Button } from 'react-bootstrap';
import { register } from '../../actions/authActions';

class RegisterForm extends Component {
  renderField = ({ input, label, type, meta: { touched, error } }) => {
    return (
      <div className={`field ${touched && error ? 'error' : ''}`}>
        <Form.Label>{label}</Form.Label>
        <Form.Control {...input} type={type} />
        {touched && error && (
          <Form.Text className='text-danger'>{error}</Form.Text>
        )}
      </div>
    );
  };

  onSubmit = formValues => {
    this.props.register(formValues);
  };

  render() {
    if (this.props.isAuthenticated) {
      return <Redirect to='/' />;
    }
    return (
      <Modal.Body>
        <p>Заполните все поля ниже для регистрации на сайте</p>
        <Form
          onSubmit={this.props.handleSubmit(this.onSubmit)}
        >
          <Form.Group as={Row} controlId="username">
            <Field
              name='username'
              type='text'
              component={this.renderField}
              label='Логин'
              validate={[required, minLength3, maxLength15]}
            />
          </Form.Group>
          <Form.Group as={Row} controlId="email">
            <Field
              name='email'
              type='email'
              component={this.renderField}
              label='Email'
              validate={required}
            />
          </Form.Group>
          <Form.Group as={Row} controlId="username">
            <Field
              name='password'
              type='password'
              component={this.renderField}
              label='Пароль'
              validate={required}
            />
          </Form.Group>
          <Form.Group as={Row} controlId="username">
            <Field
              name='password2'
              type='password'
              component={this.renderField}
              label='Подтверждение пароля'
              validate={[required, passwordsMatch]}
            />
          </Form.Group>
          <Button type="submit" className='btn'>Регистрация</Button>
        </Form>
        <p style={{ marginTop: '1rem' }}>
          Уже зарегистрированы? <Link to='/login'>Войти</Link>
        </p>
      </Modal.Body>
    );
  }
}

const required = value => (value ? undefined : 'Поле обязательно для заполнения');

const minLength = min => value =>
  value && value.length < min
    ? `Пароль должен быть не менее ${min} символов`
    : undefined;

const minLength3 = minLength(3);

const maxLength = max => value =>
  value && value.length > max ? `Пароль должен быть не более ${max} символов` : undefined;

const maxLength15 = maxLength(15);

const passwordsMatch = (value, allValues) =>
  value !== allValues.password ? 'Введенные пароли не совпадают' : undefined;

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

RegisterForm = connect(
  mapStateToProps,
  { register }
)(RegisterForm);

export default reduxForm({
  form: 'registerForm'
})(RegisterForm);